// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  COUPON_LABEL: 'Do you have a coupon?',
  COUPON_PLACEHOLDER: 'Enter your coupon code',
  ACTIVE_DISCOUNT: 'Your discount amount is {discountAmount}',
  REMOVE_COUPON: 'Remove Coupon',
  ACTIVATE_COUPON: 'Activate Coupon',
}

export default createMessages<typeof MESSAGES>(
  'UIKIT_FORM_COUPON_FIELD',
  MESSAGES
)
